import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { VisionboardItemAddRemoveClickInput } from "../models";

@Injectable()
export class VisionboardItemAddRemoveButtonService {
  private _addItemClickedSubject: Subject<VisionboardItemAddRemoveClickInput> = new Subject();
  addItemClicked$: Observable<VisionboardItemAddRemoveClickInput> = this._addItemClickedSubject.asObservable();

  private _removeItemClickedSubject: Subject<VisionboardItemAddRemoveClickInput> = new Subject();
  removeItemClicked$: Observable<VisionboardItemAddRemoveClickInput> = this._removeItemClickedSubject.asObservable();

  constructor() {}

  addItemClick(input: VisionboardItemAddRemoveClickInput): void {
    this._addItemClickedSubject.next(input);
  }

  removeItemClick(input: VisionboardItemAddRemoveClickInput): void {
    this._removeItemClickedSubject.next(input);
  }
}
